import { AlertCircle, RefreshCw, Sparkles } from "lucide-react";

const CHANNELS = [
  { v: "email", label: "Email" },
  { v: "instagram_dm", label: "Instagram DM" },
  { v: "linkedin", label: "LinkedIn" },
];
const TONES = [
  { v: "professional", label: "Professional" },
  { v: "friendly", label: "Friendly" },
  { v: "confident", label: "Confident" },
];
const GOALS = [
  { v: "product_sponsorship", label: "Product sponsorship" },
  { v: "paid_partnership", label: "Paid partnership" },
  { v: "ambassador_deal", label: "Ambassador deal" },
  { v: "event_appearance", label: "Event appearance" },
];

/**
 * Left-rail form: pick a brand, channel, tone, goal — kick off the AI generator.
 * Stateless aside from rendering; parent owns all the values + the generate handler.
 */
export default function OutreachForm({
  brands, brandId, setBrandId,
  channel, setChannel, tone, setTone, goal, setGoal,
  loading, onGenerate,
}) {
  const selected = brands.find(b => b.id === brandId);
  return (
    <div className="md:col-span-5 surface p-6 space-y-5 h-fit">
      <Field label="Brand">
        {brands.length === 0 ? (
          <div className="text-xs text-ink-muted">Add a brand first in CRM.</div>
        ) : (
          <>
            <select value={brandId} onChange={(e) => setBrandId(e.target.value)} data-testid="outreach-brand-select"
              className="w-full bg-bg border border-line focus:border-volt outline-none px-3 py-2.5 text-white">
              {brands.map(b => <option key={b.id} value={b.id}>{b.brand_name}{b.email_invalid ? " — email invalid" : ""}</option>)}
            </select>
            {selected?.email_invalid && (
              <div className="mt-2 text-xs text-[#FF3B30] flex items-start gap-2" data-testid="brand-email-invalid">
                <AlertCircle className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                <span>This brand's email previously bounced or marked your send as spam. Update the contact email on the Brands page before sending again.</span>
              </div>
            )}
          </>
        )}
      </Field>
      <Field label="Channel"><Pills options={CHANNELS} value={channel} onChange={setChannel} prefix="ch" /></Field>
      <Field label="Tone"><Pills options={TONES} value={tone} onChange={setTone} prefix="tn" /></Field>
      <Field label="Goal"><Pills options={GOALS} value={goal} onChange={setGoal} prefix="gl" /></Field>
      <button onClick={onGenerate} disabled={!brandId || loading}
        className="w-full btn-volt inline-flex items-center justify-center gap-2 disabled:opacity-40"
        data-testid="outreach-generate-btn">
        {loading ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
        {loading ? "Generating…" : "Generate pitch"}
      </button>
    </div>
  );
}

function Field({ label, children }) {
  return <div><label className="label-eyebrow block mb-2">{label}</label>{children}</div>;
}

function Pills({ options, value, onChange, prefix }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map(o => (
        <button key={o.v} type="button" onClick={() => onChange(o.v)} data-testid={`${prefix}-${o.v}`}
          className={`px-3 py-2 border text-xs uppercase tracking-widest ${
            value === o.v ? "border-volt text-volt" : "border-line text-ink-muted hover:text-white"
          }`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
